export default function mergeColumns(canonical, saved) {
  if (!saved || saved.length === 0) return canonical.map(col => ({ ...col }));
  const savedMap = Object.fromEntries(saved.map(c => [c.field_name, c.showColumn]));
  return canonical.map(col => ({
    ...col,
    showColumn: col.field_name in savedMap ? savedMap[col.field_name] : col.showColumn,
  }));
}
